import {
  Button,
  Card,
  Col,
  Collapse,
  Descriptions,
  Image,
  Modal,
  notification,
  Row,
  Select,
  Tabs,
  Tag,
} from "antd";
import AestheticDisplay from "components/shared-components/DataDisplayWidget/AestheticDisplay";
import {
  getScreenPermission,
  setBoilerId,
  useUserData,
} from "components/UserDataContext/UserDataContext";
import i18n from "lang";
import { useEffect, useState } from "react";
import { useApiService } from "services/ApiService";
import TodayPanel from "./TodayPanel";
import {
  companyLabels,
  factoryLabels,
  getAssemblyLabelsAndData,
} from "./HomeScreenLabels";
import {
  ArrowLeftOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  findFEQ_BHSectionName,
  findSectionName,
  IsCommonBoilerSection,
  IsCommonDistilleryBoilerSection,
  isFEQSection,
} from "helper/CommonFunctions";
import dayjs from "dayjs";
import { EMPTY_GUID } from "constants/AppConstant";
import { set } from "lodash";
const { TabPane } = Tabs;
const { Panel } = Collapse;
const { Option, OptGroup } = Select;
const Home = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const userData = useUserData();
  const apiService = useApiService();
  const {
    factoryId,
    companyId,
    users,
    houseImages,
    companies,
    factories,
    factoryRoles,
    assemblyLines,
    assemblyLineId,
    setSubAssemblyDetail,
    boilers,
    setBoilerId,
    setAssemblyLineId,
    millingLineId,
    distilleryBoilers,
    setDistilleryBoilerId,
    distilleryBoilerId,
  } = userData;
  const [companyObj, setCompanyObj] = useState({});
  const [factoryObj, setFactoryObj] = useState({});
  const [groupModal, setGroupModal] = useState(false);
  const [showMillingLine, setShowMillingLine] = useState(false);
  const [isMain, setIsMain] = useState(true);
  const [isAssemblies, setIsAssemblies] = useState(false);
  const [isAssemblyDetail, setIsAssemblyDetail] = useState(false);
  const [assembly, setAssembly] = useState({});
  const [subAssembly, setSubAssembly] = useState({});
  const [section, setSection] = useState(null);
  const [assemblyLabels, setAssemblyLabels] = useState([]);
  const [assemblyLabelsData, setAssemblyLabelsData] = useState([]);
  const [screenData, setScreenData] = useState({
    assemblies: [],
    subAssemblies: [],
    assembliesCount: 0,
  });
  useEffect(() => {
    navigate("/app/Home");
  }, []);
  useEffect(() => {
    setCompanyObj(companies.find((x) => x.companyId == companyId));
    setFactoryObj(factories.find((x) => x.factoryRegisterationId == factoryId));
    setIsMain(true);
    setIsAssemblies(false);
    setIsAssemblyDetail(false);
    setScreenData({
      assemblies: [],
      subAssemblies: [],
      assembliesCount: 0,
    });
  }, [factoryId]);
  const handleExpandCollapse = (key) => {
    if (
      ["FEQ", "BH", "DB"].includes(searchParams.get("house")) ||
      key.length == 0
    ) {
      searchParams.delete("house");
      setSearchParams({});
      setAssemblyLineId(EMPTY_GUID);
      setShowMillingLine(false);
    }
    if (key.length > 0) {
      const detailsArray = factoryRoles.find(
        (x) => x.title == key && x.factoryId == factoryId,
      );
      const childRoles = factoryRoles.filter(
        (role) => role.parentId === detailsArray.roleId,
      );
      var i = 0;
      var notFound = true;
      for (i = 0; i < childRoles.length; i++) {
        var sectionName = findFEQ_BHSectionName(
          factoryRoles,
          childRoles[i].roleId,
        );
        const type = typeof sectionName;
        if (type !== "number" && isFEQSection(sectionName)) {
          setSearchParams({ house: "FEQ" });
          setShowMillingLine(true);
          setAssemblyLineId(millingLineId);
          break;
        } else if (type !== "number" && sectionName.endsWith("BH")) {
          setSearchParams({ house: "BH" });
          const Id = boilers.filter((x) => x.factoryId == factoryId)[0]
            .boilerId;
          setBoilerId(Id);
          setAssemblyLineId(Id);
          setShowMillingLine(false);
          break;
        } else if (type !== "number" && sectionName.endsWith("DB")) {
          setSearchParams({ house: "DB" });
          const Id = distilleryBoilers.filter(
            (x) => x.factoryId == factoryId,
          )[0].distilleryBoilerId;
          setDistilleryBoilerId(Id);
          setAssemblyLineId(Id);
          setShowMillingLine(false);
          break;
        } else {
          setAssemblyLineId(EMPTY_GUID);
          setShowMillingLine(false);
          break;
        }
      }
    }
  };
  const handleBoilerChange = (Id) => {
    if (Id === "common") {
      setAssemblyLineId(EMPTY_GUID);
      //setBoilerId(Id);
    } else {
      setBoilerId(Id);
      setAssemblyLineId(Id);
    }
  };
  const handleDistilleryBoilerChange = (Id) => {
    if (Id === "common") {
      setAssemblyLineId(EMPTY_GUID);
    } else {
      setDistilleryBoilerId(Id);
      setAssemblyLineId(Id);
    }
  };
  const handleSectionButtonClick = (roleId) => {
    const section = findSectionName(factoryRoles, roleId);
    const type = typeof section;
    if (type === "string") {
      setIsMain(false);
      setIsAssemblies(true);
      setSection(section);
      apiService(
        `Dashboard/HomeViews?assemblyLineId=${assemblyLineId}&screenName=${section}`,
        "GET",
      )
        .then(async (res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          const data = await res.json();
          setScreenData(data);
        })
        .catch((error) => {
          console.error("Error fetching basic data:", error);
        });
    } else {
      navigate(factoryRoles.find((x) => x.roleId == roleId).path);
    }
  };
  const handleAssemblyClick = (id) => {
    const obj = assemblies.find((x) => x.assemblyId == id);
    setAssembly(obj);
    const labelsAndKeys = getAssemblyLabelsAndData(section);
    setAssemblyLabels(labelsAndKeys.map((x) => x.label));
    const dataToShow = labelsAndKeys.map((x) => {
      if (x.dataIndex.toLowerCase().includes("year") && obj[x.dataIndex]) {
        return new Date(obj[x.dataIndex]).getFullYear();
      } else if (x.format) {
        return dayjs(obj[x.dataIndex]).format(x.format);
      }
      const value = obj[x.dataIndex];
      if (value && value.includes("♪")) {
        return value.split("♪").join(" - ");
      }
      return value;
    });
    setAssemblyLabelsData([...dataToShow]);
    setIsAssemblies(false);
    setIsAssemblyDetail(true);
  };
  const handleComplete = () => {
    const data = {
      assemblyId: subAssembly.assemblyId,
      subAssemblyId: subAssembly.subAssemblyId,
      assemSubAssemblyId: subAssembly.assemblySubAssemblyId,
      viaDashboard: true,
    };
    setSubAssemblyDetail(data);
    const sparePermission = getScreenPermission(userData, `${section}_Spare`);
    if (sparePermission.canView) {
      navigate(`/app/${section}_Spare`);
    } else {
      notification.error({
        message: i18n.t("PermissionDenied"),
        description: i18n.t("NoPermissionToViewScreen"),
      });
    }
  };
  const isBoilerHouse = (roleId) => {
    const section = findFEQ_BHSectionName(factoryRoles, roleId);
    const type = typeof section;
    return type === "string" && section.endsWith("BH");
  };
  const isDistilleryBoilerHouse = (roleId) => {
    const section = findFEQ_BHSectionName(factoryRoles, roleId);
    const type = typeof section;
    return type === "string" && section.endsWith("DB");
  };
  const companyLabelsData = [
    companyObj.phoneNo,
    companyObj.email,
    companyObj.websiteURL,
    companyObj.companyDesc,
    companyObj.address,
    companyObj.contactPerson,
  ];
  const { assemblies, subAssemblies, assembliesCount } = screenData;
  return (
    <>
      {isMain && (
        <>
          <TodayPanel />
          <Card>
            <Descriptions column={1}>
              <Descriptions.Item
                label={
                  <span style={{ color: "var(--semmapp-muted)", fontWeight: 600 }}>
                    {i18n.t("Company_Name")}
                  </span>
                }
              >
                <span style={{ color: "var(--semmapp-green)", fontWeight: 600 }}>
                  {companyObj?.companyName || "N/A"}
                </span>
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span style={{ color: "var(--semmapp-muted)", fontWeight: 600 }}>
                    {" "}
                    {i18n.t("Factory")}
                  </span>
                }
              >
                <span style={{ color: "var(--semmapp-green)", fontWeight: 600 }}>
                  {factoryObj?.factoryName || "N/A"}
                </span>
              </Descriptions.Item>
            </Descriptions>
            <Button onClick={() => setGroupModal(true)} type="primary">
              {i18n.t("View_GroupDetails")}
            </Button>
          </Card>
          <Modal
            title={i18n.t("CompanyDetail")}
            centered
            footer={null}
            open={groupModal}
            width={1200}
            onCancel={() => setGroupModal(false)}
          >
            <Row className="row-gutter pt-4" gutter={16}>
              <Col lg={12}>
                <Card title="" style={{ textAlign: "left" }}>
                  <AestheticDisplay
                    labels={companyLabels()}
                    data={companyLabelsData}
                  />
                  <div style={{ flexShrink: 0, marginLeft: "20px" }}>
                    <Image
                      src={companyObj.companyLogo}
                      alt={i18n.t("CompanyImage")}
                      style={{ width: "300px", height: "auto" }}
                    />
                  </div>
                </Card>
              </Col>
              <Col lg={12}>
                <Card title="" style={{ textAlign: "left" }}>
                  <Tabs>
                    {factories
                      .filter((x) => x.companyId == companyId)
                      .map((obj, index) => {
                        const factoryLabelsData = [
                          obj.description,
                          obj.assemblyLine,
                          obj.capacity,
                          obj.startDate
                            ? new Date(obj.startDate).getFullYear()
                            : null,
                          obj.factoryAddress,
                        ];
                        return (
                          <TabPane tab={obj.factoryName} key={index}>
                            <AestheticDisplay
                              labels={factoryLabels()}
                              data={factoryLabelsData}
                            />
                          </TabPane>
                        );
                      })}
                  </Tabs>
                </Card>
              </Col>
            </Row>
          </Modal>
          <Collapse
            destroyInactivePanel
            accordion
            onChange={(key) => {
              handleExpandCollapse(key);
            }}
            expandIcon={({ isActive }) => (
              <Button
                type="link"
                icon={isActive ? <MinusOutlined /> : <PlusOutlined />}
              />
            )}
          >
            {factoryRoles
              .filter((x) => x.isHome === true && x.parentId == 0)
              // One panel per house: some factories hold two copies of their roles (QA UI-06).
              // The first copy is kept, the one handleExpandCollapse finds by title.
              .filter((x, i, all) => all.findIndex((y) => y.title === x.title) === i)
              .map((role) => (
                <Panel
                  header={<Title level={4}>{i18n.t(role.title)}</Title>}
                  key={role.title}
                >
                  {isBoilerHouse(role.roleId) ? (
                    <>
                      <Tabs
                        tabPosition="top"
                        style={{ width: "100%" }}
                        onChange={(key) => handleBoilerChange(key)}
                      >
                        {boilers
                          .filter((x) => x.factoryId === factoryId)
                          .map((b) => (
                            <TabPane
                              tab={
                                <span
                                  style={{ fontWeight: "bold", color: "var(--semmapp-green)" }}
                                >
                                  {b.boilerName}
                                </span>
                              }
                              key={b.boilerId}
                            >
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  height: "100%",
                                }}
                              >
                                {houseImages
                                  .filter((x) => x.factoryId === factoryId)
                                  .map((x, idx) => (
                                    <div key={idx}>
                                      {x.title === role.title ? (
                                        <img
                                          src={x.imageURL}
                                          alt={i18n.t("AssemblyProfileImage")}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                        />
                                      ) : null}
                                    </div>
                                  ))}
                              </div>

                              <div style={{ marginTop: 10 }}>
                                {factoryRoles
                                  .filter(
                                    (x) =>
                                      x.parentId === role.roleId &&
                                      IsCommonBoilerSection(
                                        factoryRoles,
                                        x.roleId,
                                      ) !== true,
                                  )
                                  .map((r, index) => (
                                    <Button
                                      key={index}
                                      type="primary"
                                      onClick={() =>
                                        handleSectionButtonClick(r.roleId)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        margin: "5px",
                                      }}
                                    >
                                      {r.title.toUpperCase()}
                                    </Button>
                                  ))}
                              </div>
                            </TabPane>
                          ))}
                        <TabPane
                          tab={
                            <span
                              style={{ fontWeight: "bold", color: "var(--semmapp-green)" }}
                            >
                              {i18n.t("CommonSections")}
                            </span>
                          }
                          key="common"
                        >
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            {houseImages
                              .filter((x) => x.factoryId === factoryId)
                              .map((x, idx) => (
                                <div key={idx}>
                                  {x.title === role.title ? (
                                    <img
                                      src={x.imageURL}
                                      alt={i18n.t("AssemblyProfileImage")}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                      }}
                                    />
                                  ) : null}
                                </div>
                              ))}
                          </div>
                          <div>
                            {factoryRoles
                              .filter(
                                (x) =>
                                  x.parentId === role.roleId &&
                                  IsCommonBoilerSection(
                                    factoryRoles,
                                    x.roleId,
                                  ) === true,
                              )
                              .map((r, index) => (
                                <Button
                                  key={index}
                                  type="primary"
                                  onClick={() =>
                                    handleSectionButtonClick(r.roleId)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    margin: "5px",
                                  }}
                                >
                                  {r.title.toUpperCase()}
                                </Button>
                              ))}
                          </div>
                        </TabPane>
                      </Tabs>
                    </>
                  ) : factoryRoles.filter(
                      (x) => x.parentId === role.roleId && x.isHome === true,
                    ).length > 0 ? (
                    <>
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        {houseImages
                          .filter((x) => x.factoryId === factoryId)
                          .map((x, idx) => (
                            <div key={idx}>
                              {x.title === role.title ? (
                                <img
                                  src={x.imageURL}
                                  alt={i18n.t("AssemblyProfileImage")}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                  }}
                                />
                              ) : null}
                            </div>
                          ))}
                      </div>
                      <Tabs
                        tabPosition="left"
                        onChange={(key) => {
                          handleExpandCollapse(key);
                        }}
                      >
                        {factoryRoles
                          .filter(
                            (x) =>
                              x.parentId === role.roleId && x.isHome === true,
                          )
                          .map((r, index) => (
                            <TabPane
                              tab={
                                <span style={{ fontWeight: "bold" }}>
                                  {r.title}
                                </span>
                              }
                              key={r.title}
                            >
                              {isDistilleryBoilerHouse(r.roleId) ? (
                                <>
                                  <Tabs
                                    tabPosition="top"
                                    style={{ width: "100%" }}
                                    onChange={(key) =>
                                      handleDistilleryBoilerChange(key)
                                    }
                                  >
                                    {distilleryBoilers
                                      .filter((x) => x.factoryId === factoryId)
                                      .map((b) => (
                                        <TabPane
                                          tab={
                                            <span
                                              style={{
                                                fontWeight: "bold",
                                                color: "var(--semmapp-green)",
                                              }}
                                            >
                                              {b.boilerName}
                                            </span>
                                          }
                                          key={b.distilleryBoilerId}
                                        >
                                          <div
                                            style={{
                                              position: "relative",
                                              width: "100%",
                                              height: "100%",
                                            }}
                                          >
                                            {houseImages
                                              .filter(
                                                (x) =>
                                                  x.factoryId === factoryId,
                                              )
                                              .map((x, idx) => (
                                                <div key={idx}>
                                                  {x.title === role.title ? (
                                                    <img
                                                      src={x.imageURL}
                                                      alt={i18n.t("AssemblyProfileImage")}
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                      }}
                                                    />
                                                  ) : null}
                                                </div>
                                              ))}
                                          </div>

                                          <div style={{ marginTop: 10 }}>
                                            {factoryRoles
                                              .filter(
                                                (x) =>
                                                  x.parentId === r.roleId &&
                                                  IsCommonDistilleryBoilerSection(
                                                    factoryRoles,
                                                    x.roleId,
                                                  ) !== true,
                                              )
                                              .map((r_, index) => (
                                                <Button
                                                  key={index}
                                                  type="primary"
                                                  onClick={() =>
                                                    handleSectionButtonClick(
                                                      r_.roleId,
                                                    )
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    margin: "5px",
                                                  }}
                                                >
                                                  {r_.title.toUpperCase()}
                                                </Button>
                                              ))}
                                          </div>
                                        </TabPane>
                                      ))}
                                    <TabPane
                                      tab={
                                        <span
                                          style={{
                                            fontWeight: "bold",
                                            color: "var(--semmapp-green)",
                                          }}
                                        >
                                          {i18n.t("CommonSections")}
                                        </span>
                                      }
                                      key="common"
                                    >
                                      <div>
                                        {factoryRoles
                                          .filter(
                                            (x) =>
                                              x.parentId === r.roleId &&
                                              IsCommonDistilleryBoilerSection(
                                                factoryRoles,
                                                x.roleId,
                                              ) === true,
                                          )
                                          .map((r_, index) => (
                                            <Button
                                              key={index}
                                              type="primary"
                                              onClick={() =>
                                                handleSectionButtonClick(
                                                  r_.roleId,
                                                )
                                              }
                                              style={{
                                                cursor: "pointer",
                                                margin: "5px",
                                              }}
                                            >
                                              {r_.title.toUpperCase()}
                                            </Button>
                                          ))}
                                      </div>
                                    </TabPane>
                                  </Tabs>
                                </>
                              ) : (
                                <div>
                                  {factoryRoles
                                    .filter((x) => x.parentId === r.roleId)
                                    .map((r_, index) => (
                                      <Button
                                        key={index}
                                        type="primary"
                                        onClick={() =>
                                          handleSectionButtonClick(r_.roleId)
                                        }
                                        style={{
                                          cursor: "pointer",
                                          margin: "5px",
                                        }}
                                      >
                                        {r_.title.toUpperCase()}
                                      </Button>
                                    ))}
                                </div>
                              )}
                            </TabPane>
                          ))}
                      </Tabs>
                    </>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "left",
                        transition: "transform 0.5s ease-in-out",
                      }}
                      className="responsive-container"
                    >
                      {showMillingLine && (
                        <div style={{ width: "100%", textAlign: "left" }}>
                          <h3 className="fw-bold" style={{ color: "var(--semmapp-green)" }}>
                            {
                              assemblyLines.find(
                                (x) => x.assemblyLineId === assemblyLineId,
                              )?.assemblyLineName
                            }
                          </h3>
                        </div>
                      )}
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        {houseImages
                          .filter((x) => x.factoryId === factoryId)
                          .map((x, idx) => (
                            <div key={idx}>
                              {x.title === role.title ? (
                                <img
                                  src={x.imageURL}
                                  alt={i18n.t("AssemblyProfileImage")}
                                  style={{ width: "100%", height: "100%" }}
                                />
                              ) : (
                                <></>
                              )}
                            </div>
                          ))}
                      </div>
                      <div>
                        {factoryRoles
                          .filter((x) => x.parentId === role.roleId)
                          .map((r, index) => (
                            <Button
                              key={index}
                              type="primary"
                              onClick={() => handleSectionButtonClick(r.roleId)}
                              style={{
                                cursor: "pointer",
                                margin: "5px",
                              }}
                            >
                              {r.title.toUpperCase()}
                            </Button>
                          ))}
                      </div>
                    </div>
                  )}
                </Panel>
              ))}
          </Collapse>
        </>
      )}
      {isAssemblies && (
        <>
          {assembliesCount > 0 && (
            <Row gutter={[16, 16]} className="row-gutter">
              {assemblies.map((x, index) => (
                <Col className="m-3" xxl={3} xl={3} lg={3} md={8} sm={12}>
                  <div key={index} style={{ height: "100%" }}>
                    <a
                      className="image-container"
                      href="#"
                      onClick={() => handleAssemblyClick(x.assemblyId)}
                    >
                      <div style={{ height: "100%" }}>
                        <img
                          onMouseEnter={(e) => {
                            e.target.style.border = `2px solid ${
                              x.colour || "#DB3498"
                            }`;
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.border = "2px solid transparent";
                          }}
                          src={x.imageFile}
                          alt={`Image ${index + 1}`}
                          //style={{ width: "100%", height: "100%" }}
                          style={{
                            objectFit: "cover",
                            width: "200px",
                            height: "200px",
                          }}
                        />
                        <Tag className="my-2" color="blue">
                          {x.assemblyName}
                        </Tag>
                      </div>
                    </a>
                  </div>
                </Col>
              ))}
            </Row>
          )}
          <Button
            icon={<ArrowLeftOutlined />}
            type="primary"
            className="mt-5"
            onClick={() => {
              setIsMain(true);
              setIsAssemblies(false);
              setIsAssemblyDetail(false);
              setScreenData({
                assemblies: [],
                subAssemblies: [],
                assembliesCount: 0,
              });
            }}
          >
            {i18n.t("Back")}
          </Button>
        </>
      )}
      {isAssemblyDetail && (
        <>
          <div className="responsive-container">
            <div className="app">
              <Row gutter={[16, 16]}>
                <Col xs={24} md={16} lg={12}>
                  <Card>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "left",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <AestheticDisplay
                          labels={assemblyLabels}
                          data={assemblyLabelsData}
                        />
                      </div>
                      <div style={{ flex: 1, marginLeft: "20px" }}>
                        <Image
                          src={assembly?.imageFile}
                          alt={i18n.t("AssemblyProfileImage")}
                          preview={{
                            mask: <div style={{ color: "white" }}></div>,
                          }}
                        />
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col lg={12}>
                  <Card>
                    <div style={{ alignItems: "center", textAlign: "left" }}>
                      <div style={{ marginLeft: "20px" }}>
                        <Select
                          style={{ width: "100%" }}
                          placeholder={i18n.t("Select_SubAssembly")}
                          onChange={(value) => {
                            setSubAssembly(
                              subAssemblies.find(
                                (x) =>
                                  x.subAssemblyId == value &&
                                  x.assemblyId == assembly.assemblyId,
                              ),
                            );
                          }}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) > -1
                          }
                          showSearch
                        >
                          {subAssemblies
                            .filter((x) => x.assemblyId == assembly.assemblyId)
                            .sort((a, b) =>
                              a.subAssemblyName
                                .toLowerCase()
                                .localeCompare(b.subAssemblyName.toLowerCase()),
                            )
                            .map((x) => (
                              <Option
                                key={x.subAssemblyId}
                                value={x.subAssemblyId}
                              >
                                {x.subAssemblyName}
                              </Option>
                            ))}
                        </Select>
                      </div>
                      <div
                        className="mt-2"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          style={{
                            flex: 1,
                            maxWidth: "200%",
                            maxHeight: "300px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          src={subAssembly.file_Url}
                          preview={{
                            mask: <div style={{ color: "white" }}></div>,
                          }}
                        />
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
          <Button
            icon={<ArrowLeftOutlined />}
            type="primary"
            className="mt-5"
            onClick={() => {
              setIsMain(false);
              setIsAssemblies(true);
              setIsAssemblyDetail(false);
              setAssemblyLabels([]);
              setAssemblyLabelsData([]);
              setAssembly({});
              setSubAssembly({});
            }}
          >
            {i18n.t("Back")}
          </Button>
          {subAssembly?.subAssemblyId && (
            <Button className="ml-2" onClick={handleComplete} type="primary">
              {i18n.t("Done")}
            </Button>
          )}
        </>
      )}
    </>
  );
};

export default Home;
